const title = [
    {
        title: 'Channel',
        key: 'ChannelID',
        width: '12%'
    },
    {
        title: 'Channel Order #',
        key: 'ChannelOrderID',
        width: '21%'
    },
    {
        title: 'Order Date',
        key: 'OrderDT',
        width: '15%'
    },
    {
        title: 'Country',
        key: 'DestinationCountryCH',
        width: '15%'
    },
    {
        title: 'Ship To Name',
        key: 'ConsigneeNameCH',
        width: '20%'
    },
    {
        title: 'Status',
        key: 'StatusID',
        width: '15%'
    },
]
export default title



// WEBPACK FOOTER //
// ./src/components/tab-menu/title.js